import React, {useEffect, useState} from 'react'
import './contactPage.scss'
import CONTACT_ACTIONS from './state/contactPageActions'
import MessageSent from './messageSent'
import formatPhoneNumber from '../../utils/formatPhoneNumber'
import formatLongNumber from '../../utils/formatLongNumber'
import validateEmail from '../../utils/validateEmail'
import validatePhone from '../../utils/validatePhone'
import validateNumberInput from '../../utils/validateNumberInput'

const buildYearRange = (start,end)=>{
  let years = []
  for(let year = start; year < end; year++){
    years.push(year)
  }
  return years
}

export default function ContactPage(props){
  const urlParams = new URLSearchParams(window.location.search);
  const jwt = urlParams.get('jwt')
  const tk = urlParams.get('token')

  const token = ()=>{
    if(tk){return tk}
    return(jwt)
  }

  const {id} = props

  const [tradeIn, setTradeIn] = useState(false)
  const [firstNameField, setFirstNameField] = useState("")
  const [lastNameField, setLastNameField] = useState("")
  const [emailField, setEmailField] = useState("")
  const [phoneNumberField, setPhoneNumberField] = useState("")
  const [messageField, setMessageField] = useState("")
  const [years, setYears] = useState(buildYearRange(1960, new Date().getFullYear()+2))
  const [makes, setMakes] = useState([])
  const [selectedMake, setSelectedMake] = useState("")
  const [models, setModels] = useState([])
  const [selectedModel, setSelectedModel] = useState("")
  const [selectedYear, setSelectedYear] = useState("")
  const [mileageField, setMileageField] = useState("")
  const [vinField, setVinField] = useState("")
  const [submitAttempted, setSubmitAttempted] = useState(false)
  const [messageSent, setMessageSent] = useState(false)
  const [errorSending, setErrorSending] = useState(false)
  const [loading, setLoading] = useState(false)

  const tradeInValid = (tradeIn && selectedYear.length && selectedMake.length && selectedModel.length && mileageField.length) || !tradeIn
  const firstNameValid = firstNameField.length
  const lastNameValid = lastNameField.length
  const emailValid = emailField.length && validateEmail(emailField)
  const phoneNumberValid = phoneNumberField.length && validatePhone(phoneNumberField)

  useEffect(()=>{
    getMakes()
  },[])

  useEffect(()=>{
    if(selectedMake.length){
      getModels()
    }
  },[selectedMake])

  const getMakes = ()=>{
    CONTACT_ACTIONS.getMakeList().then(response=>{
      return(response.json())
    }).then(res=>{
      if(res){
        setMakes(res)
      }
    })
  }

  const getModels = ()=>{
    CONTACT_ACTIONS.getModelList(selectedMake).then(response=>{
      return(response.json())
    }).then(res=>{
      if(res && res.models){
        setModels(res.models)
      }
    })
  }

  const allowSubmit = ()=>{
    if(phoneNumberField.length > 0){
      return(tradeInValid && firstNameValid && lastNameValid && emailValid && phoneNumberValid)
    }
    else{
      return(tradeInValid && firstNameValid && lastNameValid && emailValid)
    }
  }

  const formSubmitRequest = ()=>{
    let inquiry = {
      first_name: firstNameField,
      last_name: lastNameField,
      email: emailField,
    }
    if(phoneNumberField.length){
      inquiry.phone_number = phoneNumberField
    }
    if(messageField.length){
      inquiry.comment = messageField
    }
    if(tradeIn){
      inquiry = {
        ...inquiry,
        trade_in_make: selectedMake,
        trade_in_model: selectedModel,
        trade_in_vin: vinField,
        trade_in_mileage: mileageField,
        trade_in_year: selectedYear,
      }
    }
    return CONTACT_ACTIONS.sendVehicleInquiry(id,JSON.stringify(inquiry),token())
  }

  const formSubmit = ()=>{
    setSubmitAttempted(true)
    if(allowSubmit()){
      setLoading(true)
      setErrorSending(false)
      formSubmitRequest().then(response=>{
        if(response.status === 200 || response.status === 201){
          setMessageSent(true)
        }
        else{
          setErrorSending(true)
        }
        setLoading(false)
      }).catch(()=>{
        setErrorSending(true)
        setLoading(false)
      })
    }
  }

  if(messageSent){
    return(
      <MessageSent/>
    )
  }
  return(
    <div className="contact-page-container">
      <div className="contact-page">
        {loading?
          <div className="contact-page-loading">
            <div className="contact-page-loading-spinner"/>
          </div>
          :
          <React.Fragment/>
        }

        <div className="contact-page-title">
          Contact Dealer
        </div>

        <form className="contact-page-form">
          <div className="contact-page-form-row">
            <div className="contact-page-form-input">
              {(!firstNameValid && submitAttempted)?<div className="contact-page-form-error">Required</div>:null}
              <input
                type="text"
                placeholder="First Name"
                className="contact-page-input"
                onChange={e=>{setFirstNameField(e.target.value)}}
                value={firstNameField}
              />
            </div>

            <div className="contact-page-form-input">
              {(!lastNameValid && submitAttempted)?<div className="contact-page-form-error">Required</div>:null}
              <input
                type="text"
                placeholder="Last Name"
                className="contact-page-input"
                onChange={e=>{setLastNameField(e.target.value)}}
                value={lastNameField}
              />
            </div>
          </div>

          <div className="contact-page-form-row contact-page-form-row-single">
            {(phoneNumberField.length && !phoneNumberValid && submitAttempted)?<div className="contact-page-form-error">Please enter valid phone number</div>:null}
            <input
              type="text"
              placeholder="Phone (Optional)"
              className="contact-page-input"
              onChange={e=>{setPhoneNumberField(e.target.value)}}
              value={formatPhoneNumber(phoneNumberField) || phoneNumberField}
              maxLength={10}
            />
          </div>

          <div className="contact-page-form-row contact-page-form-row-single">
            {(!emailValid && submitAttempted)?<div className="contact-page-form-error">Please enter valid email address</div>:null}
            <input
              type="text"
              placeholder="Email"
              className="contact-page-input"
              onChange={e=>{setEmailField(e.target.value)}}
              value={emailField}
            />
          </div>

          <div className="contact-page-form-row contact-page-form-row-single">
            <textarea
              className="contact-page-input contact-page-textarea"
              placeholder="Message (Optional)"
              onChange={e=>{setMessageField(e.target.value)}}
              value={messageField}
            />
          </div>

          <div className="contact-page-form-row contact-page-form-row-checkbox">
            <input
              type="checkbox"
              onChange={()=>{setTradeIn(!tradeIn)}}
              checked={tradeIn}
            />
            Do you have a trade-in?
          </div>

          {tradeIn?
            <div>
              <div className="contact-page-form-row">
                <div className="contact-page-form-input">
                  {(tradeIn && submitAttempted && !selectedYear.length)?<div className="contact-page-form-error">Required</div>:null}
                  <select
                    onChange={e=>{setSelectedYear(e.target.value)}}
                    className="contact-page-dropdown"
                    value={selectedYear}
                  >
                    <option value="">Year</option>
                    {years.map(year=>{
                      return(
                        <option value={year} key={year}>{year}</option>
                      )
                    })}
                  </select>
                </div>

                <div className="contact-page-form-input">
                  {(tradeIn && submitAttempted && !selectedMake.length)?<div className="contact-page-form-error">Required</div>:null}
                  <select
                    onChange={e=>{setSelectedMake(e.target.value)}}
                    className="contact-page-dropdown"
                    value={selectedMake}
                    disabled={!selectedYear.length}
                  >
                    <option value="">Make</option>
                    {makes.map(make=>{
                      return(
                        <option value={make} key={make}>{make}</option>
                      )
                    })}
                  </select>
                </div>
              </div>

              <div className="contact-page-form-row contact-page-form-row-single">
                <div className="contact-page-form-input">
                  {(tradeIn && submitAttempted && !selectedModel.length)?<div className="contact-page-form-error">Required</div>:null}
                  <select
                    onChange={e=>{setSelectedModel(e.target.value)}}
                    className="contact-page-dropdown"
                    value={selectedModel}
                    disabled={!selectedMake.length}
                  >
                    <option value="">Model</option>
                    {models.map(model=>{
                      return(
                        <option value={model} key={model}>{model}</option>
                      )
                    })}
                  </select>
                </div>
              </div>

              <div className="contact-page-form-row">
                <div className="contact-page-form-input">
                  {(tradeIn && submitAttempted && !mileageField.length)?<div className="contact-page-form-error">Please enter mileage</div>:null}
                  <input
                    type="text"
                    className="contact-page-input"
                    placeholder="Mileage"
                    onChange={e=>{setMileageField(e.target.value.replace(/,/g,''))}}
                    value={formatLongNumber(mileageField) || ""}
                    onKeyPress={e=>{validateNumberInput(e)}}
                    maxLength="10"
                  />
                </div>

                <div className="contact-page-form-input">
                  <input
                    type="text"
                    className="contact-page-input"
                    placeholder="VIN (Optional)"
                    onChange={e=>{setVinField(e.target.value)}}
                    value={vinField}
                    maxLength={17}
                  />
                </div>
              </div>
            </div>
            :
            <React.Fragment/>
          }

          {errorSending?
            <div className="contact-page-form-row contact-page-form-row-single">
              <div className="contact-page-form-error contact-page-form-error-submit">
                An error occurred, please try again later
              </div>
            </div>
            :
            <React.Fragment/>
          }

          <div className="contact-page-form-row contact-page-form-row-single contact-page-form-row-button">
            <input
              value="Contact Dealer"
              className="contact-page-button"
              onClick={formSubmit}
              type="button"
            />
          </div>

          <div className="contact-page-message-bottom">
            <div className="contact-page-message">
              By clicking here, you authorize iPacket.us and its sellers/partners to contact
              you by texts/calls which may include marketing and be by autodialer. Calls
              may be pre-recorded. You also agree to our Privacy Statement. Consent is
              not required to purchase goods/services.
            </div>
            <div className="contact-page-message">
              We value your privacy. <a href="https://www.ipacket.us/dealer-center/privacy-policy" rel="noopener noreferrer" target="_blank"><span className="contact-page-message-privacy">iPacket Privacy Statement.</span></a>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
